import { createContext } from 'use-context-selector';
import { defaultNotificationsProviderState } from './defaultState';
import { NotificationsProviderState } from './types';

const NotificationsContext = createContext<NotificationsProviderState>(defaultNotificationsProviderState);

export default NotificationsContext;
